import { ApiErrorType } from '@app/models/types/api-error.type';

export function isError(response: any): response is ApiErrorType {
    return 'details' in response && 'message' in response && 'status' in response && 'timeStamp' in response;
}
